export default __webpack_public_path__ + "static/media/Oranges.979f1636.png";